import { hasPermissions } from 'utils/permissions';

const items = [];

const catalogItems = [
  {
    href: '/pld/catalogs/actions',
    title: 'actions',
    permission: 'pld.select',
  },
  {
    href: '/pld/catalogs/monetary_instruments',
    title: 'Instrumentos monetarios',
    permission: 'pld.select.listInstruments',
  },
  {
    href: '/pld/catalogs/country_jurisdiction',
    title: 'country_jurisdiction',
    permission: 'pld.select.listJurisdictions',
  },
  {
    href: '/pld/catalogs/nationalities',
    title: 'nationalities',
    permission: 'pld.select.listNationalities',
  },
  {
    href: '/pld/catalogs/economic_activity',
    title: 'economic_activity',
    permission: 'pld.select.listEconomicActivity',
  },
  {
    href: '/pld/catalogs/operation_master',
    title: 'Maestro de operaciones',
    permission: 'pld.select.listOperationMaster',
  },
  {
    href: '/pld/catalogs/parameters',
    title: 'Parámetros generales',
    permission: 'pld.select',
  },
  {
    href: '/pld/catalogs/reporting_reasons',
    title: 'Razones de reporte',
    permission: 'pld.select',
  },
  {
    href: '/pld/catalogs/alert_types',
    title: 'Tipos de alertas',
    permission: 'pld.select.listAlertTypes',
  },
  {
    href: '/pld/catalogs/operation_types',
    title: 'Tipo de operación',
    permission: 'pld.select',
  },
  {
    href: '/pld/catalogs/person_type',
    title: 'Tipo de persona',
    permission: 'pld.select.listPersonType',
  },
  {
    href: '/pld/catalogs/black_list',
    title: 'Lista de personas bloqueadas',
    permission: 'pld.select.listBlackList',
  },
  {
    href: '/pld/catalogs/risk',
    title: 'Niveles de riesgo',
    permission: 'pld.select.listRisk',
  },
];

const allowedCatalogItems = catalogItems.filter((item) => hasPermissions(item.permission));

if (allowedCatalogItems.length > 0) {
  items.push({
    title: 'catalogs',
    items: allowedCatalogItems.map(({ permission, ...item }) => item),
  });
}

const allowedAlertingItems = [
  {
    href: '/pld/alerts',
    title: 'alerts',
    permission: 'pld.select.listAlerts',
  },
  {
    href: '/pld/customer_accounts',
    title: 'customer_accounts',
    permission: 'pld.select',
  },
  {
    href: '/pld/queries',
    title: 'queries',
    permission: 'pld.select',
  },
]
  .filter((item) => hasPermissions(item.permission))
  .map(({ permission, ...item }) => item);

if (allowedAlertingItems.length > 0) {
  items.push({
    title: 'Alertamiento',
    items: allowedAlertingItems,
  });
}

if (hasPermissions('pld.select')) {
  items.push({
    title: 'Análisis',
    items: [
      {
        href: '/pld/analysis/black_list',
        title: 'Búsquedas individuales',
      },
      {
        href: '/pld/analysis/risk_matrix',
        title: 'Matriz de riesgo',
      },
      {
        href: '/pld/analysis/client_movements',
        title: 'Movimientos por cliente',
      },
      {
        href: '/pld/analysis/binnacle',
        title: 'Bitácora PLD',
      },
    ],
  });
}

if (hasPermissions('pld.select')) {
  items.push({
    items: [
      {
        href: '/pld/reports/calendar',
        title: 'calendar',
      },
      {
        href: '/pld/reports/investigation_cases',
        title: 'investigation_cases',
      },
      {
        href: '/pld/reports/internal',
        title: 'internal',
      },
    ],
    title: 'reports',
  });
}

export default items;
